<template>
  <main class="privacy">
    <Header/>
    <section class="template-header d-flex justify-center align-center text-center">
      <div class="shadow"></div>
      <div class="item">
        <h1 class="font-weight-regular text-uppercase px-4">{{ $vuetify.lang.t('$vuetify.privacy.template-header.title') }}</h1>
      </div>
    </section>
    <section class="template pt-6 pb">
      <v-container>
        <div class="row">
          <div class="col">
            <h3 class="mb-3">{{ $vuetify.lang.t('$vuetify.privacy.template.section1.title') }}</h3>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section1.span') }}</span>
          </div>
        </div>
        <div class="row pt-6">
          <div class="col">
            <h3 class="mb-3">{{ $vuetify.lang.t('$vuetify.privacy.template.section2.title') }}</h3>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span1') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span2') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span3') }}</span><br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span4') }}</span><br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span5') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span6') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span7') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span8') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span9') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span10') }}</span><br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span11') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span12') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section2.span13') }}</span>
          </div>
        </div>
        <div class="row pt-6">
          <div class="col">
            <h3 class="mb-3">{{ $vuetify.lang.t('$vuetify.privacy.template.section3.title') }}</h3>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section3.span1') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section3.span2') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section3.span3') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section3.span4') }}</span> <br>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section3.span5') }}</span>
          </div>
        </div>
        <div class="row pt-6">
          <div class="col">
            <h3 class="mb-3">{{ $vuetify.lang.t('$vuetify.privacy.template.section4.title') }}</h3>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section4.span') }}</span>
          </div>
        </div>
        <div class="row pt-6">
          <div class="col">
            <h3 class="mb-3">{{ $vuetify.lang.t('$vuetify.privacy.template.section5.title') }}</h3>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section5.span') }}</span>
          </div>
        </div>
        <div class="row pt-6">
          <div class="col">
            <h3 class="mb-3">{{ $vuetify.lang.t('$vuetify.privacy.template.section6.title') }}</h3>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section6.span') }}</span>
          </div>
        </div>
        <div class="row pt-6">
          <div class="col">
            <h3 class="mb-3">{{ $vuetify.lang.t('$vuetify.privacy.template.section7.title') }}</h3>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section7.span') }}</span>
          </div>
        </div>
        <div class="row pt-6">
          <div class="col">
            <h3 class="mb-3">{{ $vuetify.lang.t('$vuetify.privacy.template.section8.title') }}</h3>
            <span>{{ $vuetify.lang.t('$vuetify.privacy.template.section8.span') }}</span>
          </div>
        </div>
      </v-container>
    </section>
    <Footer/>
  </main>
</template>

<script>
  import Header from '../components/Header.vue'
  import Footer from '../components/Footer.vue'
  export default {
    components: {
      Header,
      Footer
    }
  }
</script>

<style lang="scss">
  #app {
    .privacy {
      height: 100%;
      .template-header {
        background: url('../assets/background.jpg') center center /cover;
        .shadow {
          opacity: 1;
        }
      }
      .template {
        span {
          font-size: 90%;
        }
      }
    }
  }
</style>